module.exports = __webpack_public_path__ + "94ca73d9a533c2469d74aad638305925.svg";